import _ from 'lodash';

/**
 * Scroll page to passed in element respecting header offset, passed in offset, duration, and easing
 * @param {object|string} element   An Element object or string to be turned into element object
 * @param {number} extraOffset      Additional offset for scrolling beyond header height
 * @param {number} duration        length of time to be applied to scroll animation
 * @param {string} easing           Easing type for animation
 */
export function scrollToElement(element, extraOffset = 0, duration = 500, easing = 'easeOutCirc') {
    const headerHeight = $('.js-global-header-wrap').height();

    let el = element;

    // If passed in element is not already a jQuery reference object then make it one
    if (!_.isObject(el) || typeof el.offset !== 'function') {
        el = $(element);
    }

    // Only try to scroll if there is an offset method available
    if (typeof el.offset === 'function') {
        const $body = $('body');
        const properties = {
            scrollTop: el.offset().top - headerHeight - extraOffset,
            easing: easing
        };

        if ($body.hasClass('has-modal-open')) {
            $('.dom-modal').animate(properties, duration);
        } else {
            $('html, body').animate(properties, duration);
        }
    }
}

/**
 * Check whether an element is in view or not
 * @param  {object} element    An Element object
 * @return {boolean} is in view or not
 */
export function getIsElementInViewport(element) {
    const elementRect = element.getBoundingClientRect();
    const isInView =
        elementRect.top < window.innerHeight && elementRect.bottom > 0;

    return isInView;
}
